import { FanPageLayout } from "@layouts/FanPageLayout";

const FanPage = ({ isShowInfoUser }: { isShowInfoUser?: boolean }) => <FanPageLayout isShowInfoUser={isShowInfoUser} />;

export default FanPage;

